import React, { useState, useRef, useCallback, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from "react-bootstrap";
import TextField from "@mui/material/TextField";

import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import UploadFileIcon from '@mui/icons-material/UploadFile';

// const FACING_MODE_ENVIRONMENT = { facingMode: { exact: 'environment' } };
// const FACING_MODE_USER = { facingMode: 'user' };


function CameraAddMore(props) {
  const [addedImages, setAddedImages] = useState([]); // Store added images
  const [addedTextImages, setAddedTextImages] = useState([]); // Store added text of images
  const [addedObjIDImages, setAddedObjIDImages] = useState([]); // Store objectID of images
  const [facingMode, setFacingMode] = useState("environment");
  const [activeTopic, setActiveTopic] = useState(null);
  const [viewImage, setViewImage] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false); // Track new images
  const [cameraVisible, setCameraVisible] = useState(false);
  const [uploadAble, setUploadAble] = useState(false);  // true == can upload file

  const [pendingImage, setPendingImage] = useState(null);
  const [pendingTopic, setPendingTopic] = useState(null);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  const startCamera = useCallback(() => {
  const constraints = {
    video: {
      // width: { ideal: 1920 },
      // height: { ideal: 1080 },
      width: { ideal: 1400 },
      height: { ideal: 933 },
      facingMode,
    },
    audio: false,
  };

    navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
        streamRef.current = stream;
        if (videoRef.current) {
            videoRef.current.srcObject = stream;
            videoRef.current.onloadedmetadata = () => {
            videoRef.current.play();
            console.log(
                "Camera resolution:",
                videoRef.current.videoWidth,
                videoRef.current.videoHeight
            );
            };
        }
        setCameraVisible(true);
        })
        .catch((err) => {
        console.error("Camera error:", err);
        setCameraVisible(false);
        });
    }, [facingMode]);


  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
  };

  useEffect(() => {
    // console.log("width",window.innerWidth);
      if(props.previousData){
        // console.log("props.previousData",props.previousData);
        setAddedImages(props.previousData);
        if(props.previousTextData){
          // console.log("props.previousTextData",props.previousTextData);
          setAddedTextImages(props.previousTextData);
        }
        if(props.previousObjID){
          // console.log("props.previousObjID",props.previousObjID);
          setAddedObjIDImages(props.previousObjID);
        }
      }
        if(props.uploadAble){
          setUploadAble(props.uploadAble);
          // console.log("uploadAble", uploadAble);
        }
  }, []);

  useEffect(() => {
    if (cameraVisible) {
      startCamera();
    } else {
      stopCamera();
    }
    return () => stopCamera();
  }, [cameraVisible, startCamera]);

  const switchCamera = () => {
    setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
  };

  const capture = () => {
    if (!videoRef.current || !canvasRef.current) return;
    const video = videoRef.current;
    const canvas = canvasRef.current;
    // canvas.width = video.videoWidth;
    // canvas.height = video.videoHeight;
    const maxWidth = 1400;
    const maxHeight = 933;

    let scale = Math.min(maxWidth / video.videoWidth, maxHeight / video.videoHeight);
    const targetWidth = video.videoWidth * scale;
    const targetHeight = video.videoHeight * scale;

    canvas.width = targetWidth;
    canvas.height = targetHeight;

    const ctx = canvas.getContext("2d");
    // ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    // const imageData = canvas.toDataURL("image/png");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";

    // if(imageData){
    //   setAddedImages((prev) => {
    //     const newImages = [...prev];
    //     newImages[newImages.length] = imageData;
    //       if(props.onCapture){
    //         props.onCapture(newImages);
    //       }
    //     return newImages;
    //   });
    //   // console.log("addedImages", addedImages);
    // }

    ctx.drawImage(video, 0, 0, targetWidth, targetHeight);
    // บันทึกเป็น JPEG คุณภาพ 90%
    const imageData = canvas.toDataURL("image/jpeg", 0.9);

    setPendingImage(imageData);
    setPendingTopic(activeTopic);

    // console.log("imageData",imageData);
      // if(props.onCapture){
      //   props.onCapture(addedImages);
      // }
    closeCamera();
  };

  const closeCamera = () => {
    stopCamera();
    setCameraVisible(false);
    setActiveTopic(null);
    setIsAddingNew(false);
  };

  const openCameraForTopic = (topic) => {
    setActiveTopic(topic);
    setIsAddingNew(false);
    setCameraVisible(true);
  };

  const openCameraForNewImage = () => {
    setActiveTopic(null);
    setIsAddingNew(true);
    setCameraVisible(true);
  };

  const handleImageUpload = (e) => {  // ตอนกด upload (browse file)
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        if (activeTopic !== null) {
          // console.log("see camera add more 109");
          // setAddedImages((prev) => {
          //   const newImages = [...prev];
          //   newImages[activeTopic.id - 1] = base64;
          //   return newImages;
          // });
        } else {
          // console.log("activeTopic else");
          // setAddedImages((prev) => [...prev, base64]);
          setAddedImages((prev) => {
            const newImages = [...prev];
            // console.log("length",newImages.length);
            newImages[newImages.length] = base64;
              if(props.onCapture){
                props.onCapture(newImages);
              }
            return newImages;
          });
            // console.log("handleCapture addedTextImages", addedTextImages);
            setAddedTextImages((prev) => {
                const newObjImage = [...prev];
                // console.log("newObjImage",capturedImages.length,newObjImage);
                newObjImage[addedImages.length] = ''; // ==> เอา default เป็น '' ไปก่อน
                return newObjImage;
            });
        }
        closeCamera();
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (index, isFromAddedList = false) => {
    if (isFromAddedList) {
      console.log("remove index", index, addedImages, addedTextImages, addedObjIDImages);
      setAddedImages((prev) => prev.filter((_, i) => i !== index));
        // setAddedTextImages((prev) => prev.filter((_, i) => i !== index));

        // console.log("addedTextImages", addedTextImages[index]);
        // console.log(Object.values(addedTextImages));
        // console.log(Object.values(addedTextImages).filter(item => item !== addedTextImages[index]));
        setAddedTextImages((prev) => prev.filter((_, i) => i !== index));
        setAddedObjIDImages((prev) => prev.filter((_, i) => i !== index));

        // console.log(Object.values(users).filter(user => user.user_id === 1));
        // console.log(Object.keys(addedTextImages).filter(item => item.key === index));
        // console.log(Object.keys(addedTextImages));
        // const newList = Object.keys(addedTextImages).filter((_, i) => i !== index);
        // newList.map((img, i) => (
        //   console.log("newwww i",i)
        // ))
        // console.log("newlist", newList.filter((_, i) => i !== index));
        // setAddedTextImages(newList);


      // console.log("new ", addedImages, addedTextImages);
      if(props.onRemoveImage){
        props.onRemoveImage(index, addedImages, addedTextImages, addedObjIDImages);
      }
    }
    setViewImage(null);
  };

  function handleTextChange(e) {
    const { id, value } = e.target;
    // console.log("handleTextChange in AddMore", addedTextImages);
    // // Take the previous state (object), and update it
    // // by spreading (copying) out the previous object,
    // // and adding a new property with the id as key
    // // and the value as the value.
    // setAddedTextImages(prev => ({ ...prev, [id]: value }));  // code นี้มันทำให้ค่า inputTextImagesData กลายเป็น object จึงใช้ไม่ได้
      setAddedTextImages(prev => {
          // แปลง id (ที่อาจเป็น string) ให้เป็นตัวเลขสำหรับใช้เป็น index
          const targetIndex = Number(id);

          // ใช้ (prev ?? []) เพื่อป้องกัน error หาก state เริ่มต้นเป็น null/undefined
          // .map() จะสร้าง array ใหม่เสมอ (หลักการ Immutability ของ React)
          return (prev ?? []).map((item, index) => {
            // ตรวจสอบว่าใช่ index ที่เราต้องการแก้ไขหรือไม่
            if (index === targetIndex) {
              // ถ้าใช่ ให้คืนค่า value ใหม่จาก TextChange
              return value;
            }
            // ถ้าไม่ใช่ index ที่ต้องการแก้ ก็คืนค่าเดิมไป
            return item;
          });
        });

    // console.log("addedTextImages",addedTextImages);

    if(props.onTextChange){
      props.onTextChange(e);
    }
  }

  const uploadImageToAPI = async (base64Data) => {
    try {
      console.log("อัปโหลดสำเร็จ");
        // //// call api saveImage //// มันมีปัญหา เอาออกไปก่อน
        // if(props.onSaveImage){
        //   props.onSaveImage(base64Data);
        // }
      return true;
    } catch (err) {
      console.error("อัปโหลดล้มเหลว:", err);
      return false;
    }
  };

  const confirmUpload = async () => { //// ตอนกด capture
    if (!pendingImage) return;

    const ok = await uploadImageToAPI(pendingImage);
    if (!ok) return;

    // if (pendingTopic !== null) {
    //   setAddedImages((prev) => {
    //     const newImages = [...prev];
    //     newImages[pendingTopic.id - 1] = pendingImage;
    //       if(props.onCapture){
    //         props.onCapture(newImages);
    //       }
    //     return newImages;
    //   });
    // } else {
    //   setAddedImages((prev) => [...prev, pendingImage]);
    // }

    if(pendingImage){
      setAddedImages((prev) => {
        const newImages = [...prev];
        newImages[newImages.length] = pendingImage;
          if(props.onCapture){
            props.onCapture(newImages);
          }
        return newImages;
      });
        // console.log("handleCapture addedTextImages", addedTextImages);
        setAddedTextImages((prev) => {
            const newObjImage = [...prev];
            // console.log("newObjImage",capturedImages.length,newObjImage);
            newObjImage[addedImages.length] = ''; // ==> เอา default เป็น '' ไปก่อน
            return newObjImage;
        });
      // console.log("addedImages", addedImages);
    }

    setPendingImage(null);
    setPendingTopic(null);
  };

  const cancelUpload = () => {
    setPendingImage(null);
    setPendingTopic(null);
  };

  function getValueTest() {
      console.log("getValueTest", addedImages, addedTextImages, addedObjIDImages);
  }

  return (
    <div className="container text-center pt-3">

      {/* Camera Overlay */}
      {(activeTopic || isAddingNew) && (
        <div className="position-fixed top-0 start-0 w-100 h-100 bg-dark d-flex flex-column justify-content-center align-items-center" style={{ zIndex: 1050 }}>
         <video
            ref={videoRef}
            onLoadedMetadata={() => {
                const video = videoRef.current;
                console.log("Video resolution:", video.videoWidth, "x", video.videoHeight);
            }}
            className="w-100 h-100 object-fit-contain"
            playsInline
            muted
            />

          <canvas ref={canvasRef} style={{ display: "none" }} />
          <input type="file" accept="image/*" onChange={handleImageUpload} style={{ display: "none" }} id="upload-input" />

          <div className="position-absolute bottom-0 mb-3 d-flex gap-3">
            {/*<button type="button" className="btn btn-secondary" onClick={switchCamera}><CameraswitchIcon /></button>*/}
            {uploadAble?
              <label htmlFor="upload-input" className="btn btn-secondary mb-0"><UploadFileIcon /></label>
            :null}
            <button type="button" className="btn btn-primary" onClick={capture}><PhotoCameraIcon /></button>
            <button type="button" className="btn btn-danger" onClick={closeCamera}>ปิด</button>
          </div>
        </div>
      )}

      {/* Modal แสดงภาพ */}
      <Modal show={!!viewImage} onHide={() => setViewImage(null)} centered>
        <Modal.Body className="text-center">
          {viewImage && <img src={viewImage.src} alt="Captured" className="w-100" />}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={() => removeImage(viewImage.index, viewImage.isFromAddedList)}>ลบ</button>
          <button type="button" className="btn btn-secondary" onClick={() => setViewImage(null)}>ปิด</button>
        </Modal.Footer>
      </Modal>


      {/* Modal ยืนยัน */}
      <Modal show={!!pendingImage} onHide={cancelUpload} centered>
        <Modal.Body className="text-center">
          {pendingImage && (
            <img src={pendingImage} alt="Preview" className="w-100 mb-3" />
          )}
          <p>คุณต้องการอัปโหลดรูปนี้หรือไม่?</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={cancelUpload}>ยกเลิก</button>
          <button className="btn btn-primary" onClick={confirmUpload}>ยืนยัน</button>
        </Modal.Footer>
      </Modal>


      {/* เพิ่มรูปภาพเพิ่มเติม */}
      <button type="button" className="btn btn-primary mt-2 text-nowrap" 
        // onClick={() => setIsAddingNew(true)}
        onClick={openCameraForNewImage}
      >
        <PhotoCameraIcon/> {props.btnText?props.btnText:"Add More"}
      </button>
      <button type="button" style={{display:'none'}} className="btn btn-primary mt-2 text-nowrap" onClick={getValueTest}>
        test get image
      </button>

      {/* รูปภาพที่ show แบบมี text กำกับ */}
      <div className="mt-3">
        <div className="row">
          {addedImages.map((img, index) => (
            <div key={index} className="col-6 p-2">
              <div className="border p-3 d-flex flex-column align-items-center">
                <img
                  src={img}
                  alt="Added Capture"
                  style={{ width: '100%', height: 'auto', cursor: 'pointer', objectFit: 'cover' }}
                  onClick={() => setViewImage({ src: img, index, isFromAddedList: true })}
                />
                {
                  props.addTextLabel?
                    <TextField
                        // {...register("plate_no")}
                        fullWidth
                        id={index}
                        // label={index}
                        // onChange={props.onTextChange?props.onTextChange:null}
                        onChange={handleTextChange}
                        InputLabelProps={{ shrink: true }}
                        required
                        style={{marginTop:'15px'}}
                        value={addedTextImages[index]}
                    />
                  :null
                }
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CameraAddMore;
